export const SITE_ZOOM_OPTIONS = [{ value: 1, label: "100%" }, { value: 0.8, label: "80%" }, { value: 0.7, label: "70%" }] as const;

export type SiteZoom = (typeof SITE_ZOOM_OPTIONS)[number]["value"];

export const DEFAULT_SITE_ZOOM: SiteZoom = 1;
